<template>
  <v-dialog v-model="dialog" width="600" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>THÊM GHI CHÚ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <violation-new-form ref="form" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="cancel">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ViolationNewForm from './ViolationNewForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    ViolationNewForm,
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions('violation', ['createViolation']),
    async save() {
      if (!this.$refs.form.validate()) return
      this.loading = true
      const { classData, ...data } = this.$refs.form.getData()
      await this.createViolation({ ...data, class: classData })
      this.$alert.success('Tạo mới thành công')
      this.$emit('done')
      this.$refs.form.resetDefault()
      this.loading = false
      this.dialog = false
    },
    cancel() {
      this.dialog = false
      this.$refs.form.reset()
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
